module.exports = __webpack_public_path__ + "static/img/cloud_xpress_connect_img_3.ccda478.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud_xpress_connect_img_3.jpg
// module id = G/uU
// module chunks = 0